import { render, staticRenderFns } from "./StrapiEquipeComponent.vue?vue&type=template&id=14883d26"
import script from "./StrapiEquipeComponent.vue?vue&type=script&lang=js"
export * from "./StrapiEquipeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports